// src/components/dashboards/add_patient_v2/dnd/useFileDropGuard.ts
// -----------------------------------------------------------------------------
// Window-level guard against the browser's native file-drop default. Without it,
// Chrome intermittently wins and performs its default action (open the file /
// navigate away) when a file is dropped over an element whose dragover wasn't
// prevented — e.g. just off the form, or over a child the dropzone didn't cover.
// This is the standard "Gmail" fix: unconditionally preventDefault dragover +
// drop for file drags, app-wide. It is cheap (preventDefault only — no layout,
// hit-testing, or setState) and leaves text/element drags untouched.
// -----------------------------------------------------------------------------

import { useEffect } from "react";

/** Installs the global preventDefault guard for file drags while mounted. */
export function useFileDropGuard(): void {
  useEffect(() => {
    const prevent = (e: DragEvent) => {
      // Only for file drags (leave text/element drags alone).
      if (e.dataTransfer && Array.from(e.dataTransfer.types).includes("Files")) {
        e.preventDefault();
      }
    };
    window.addEventListener("dragover", prevent);
    window.addEventListener("drop", prevent);
    return () => {
      window.removeEventListener("dragover", prevent);
      window.removeEventListener("drop", prevent);
    };
  }, []);
}
